const middleware = {}

middleware['auth'] = require('../client/middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['axios'] = require('../client/middleware/axios.js')
middleware['axios'] = middleware['axios'].default || middleware['axios']

middleware['sniff'] = require('../client/middleware/sniff.js')
middleware['sniff'] = middleware['sniff'].default || middleware['sniff']

middleware['webpEnable'] = require('../client/middleware/webpEnable.js')
middleware['webpEnable'] = middleware['webpEnable'].default || middleware['webpEnable']

export default middleware
